import { render, staticRenderFns } from "./1045.vue?vue&type=template&id=db58935a&scoped=true&"
import script from "./1045.vue?vue&type=script&lang=js&"
export * from "./1045.vue?vue&type=script&lang=js&"
import style0 from "./1045.vue?vue&type=style&index=0&id=db58935a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db58935a",
  null
  
)

export default component.exports